var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticStyle:{"list-style":"none","padding-left":"0"}},_vm._l((_vm.roomTypes),function(amount,roomType){return _c('li',{key:roomType},[_vm._v(" "+_vm._s(amount)+"x "+_vm._s(roomType)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }